// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"d7adf91ff2dda7cfa8d1","655":"1fd2235571f1f8dda0a1"}[chunkId] + ".js";
};